import { Check, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const getPasswordCriteria = (password: string) => {
  return {
    minLength: password.length >= 8,
    uppercase: /[A-Z]/.test(password),
    lowercase: /[a-z]/.test(password),
    number: /[0-9]/.test(password),
    special: /[^A-Za-z0-9]/.test(password),
  };
};

export const PasswordCriteriaList = ({ password }: { password: string }) => {
  const { t } = useTranslation();

  const criteriaLabels: [keyof ReturnType<typeof getPasswordCriteria>, string][] = [
    ['minLength', t('passwordCriteria.minLength')],
    ['uppercase', t('passwordCriteria.uppercase')],
    ['lowercase', t('passwordCriteria.lowercase')],
    ['number', t('passwordCriteria.number')],
    ['special', t('passwordCriteria.special')],
  ];

  if (!password.length) return null;

  const criteria = getPasswordCriteria(password);

  return (
    <ul className="space-y-1 rounded-xl border border-slate-100 bg-slate-50 p-3 text-xs">
      {criteriaLabels.map(([key, label]) => {
        const met = criteria[key];
        return (
          <li
            key={key}
            className={`flex items-center gap-2 ${met ? 'text-green-600' : 'text-slate-400'}`}
          >
            {met ? <Check className="h-3 w-3" /> : <X className="h-3 w-3" />}
            {label}
          </li>
        );
      })}
    </ul>
  );
};
